/**
 * Customer Login Drawer
 * Maneja el modal de inicio de sesión sin redirigir a otra página
 */

(function() {
  'use strict';
  
  // console.log('🔵 Customer Login Drawer script loaded!');

  function CustomerLoginDrawer() {
    // console.log('🔵 CustomerLoginDrawer constructor called');
    
    this.drawer = document.querySelector('[data-customer-login-drawer]');
    
    if (!this.drawer) {
      console.error('❌ Customer Login Drawer: Drawer element not found!');
      return;
    }

    // console.log('✅ Customer Login Drawer: Drawer found', this.drawer);

    this.closeButtons = this.drawer.querySelectorAll('[data-drawer-close]');
    this.underlay = this.drawer.querySelector('[data-drawer-underlay]');

    this.init();
  }

  CustomerLoginDrawer.prototype.init = function() {
    // console.log('🔵 Customer Login Drawer: Initializing...');
    
    // Marcar como inicializado
    this.drawer.classList.add('initialized');
    
    var self = this;
    
    // Botones para abrir el drawer
    var loginButtons = document.querySelectorAll('[data-customer-login-toggle]');
    // console.log('🔍 Customer Login Drawer: Found ' + loginButtons.length + ' login buttons', loginButtons);
    
    loginButtons.forEach(function(button) {
      // console.log('➕ Adding click event to button:', button);
      button.addEventListener('click', function(e) {
        e.preventDefault();
        // console.log('🖱️ Customer Login Drawer: Button clicked!');
        self.open();
      });
    });

    // Cerrar drawer
    this.closeButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        self.close();
      });
    });

    // Cerrar al hacer click en el underlay
    if (this.underlay) {
      this.underlay.addEventListener('click', function() {
        self.close();
      });
    }

    // Cerrar con tecla ESC
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && self.drawer.classList.contains('is-open')) {
        self.close();
      }
    });

    // Auto-abrir si hay errores de formulario
    this.checkForErrors();
  };

  CustomerLoginDrawer.prototype.open = function() {
    // console.log('📂 Customer Login Drawer: Opening...');
    this.drawer.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    
    var self = this;
    
    // Pequeño delay para que el navegador renderice el drawer fuera de pantalla
    setTimeout(function() {
      self.drawer.classList.add('is-open');
    }, 10);
    
    // Focus en el primer campo
    setTimeout(function() {
      var firstInput = self.drawer.querySelector('input:not([type="hidden"])');
      if (firstInput) firstInput.focus();
    }, 400);

    // Dispatch evento personalizado
    document.dispatchEvent(new CustomEvent('theme:customer-login:open'));
  };

  CustomerLoginDrawer.prototype.close = function() {
    // console.log('📁 Customer Login Drawer: Closing...');
    this.drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    
    var self = this;
    setTimeout(function() {
      self.drawer.setAttribute('hidden', '');
    }, 300);

    // Dispatch evento personalizado
    document.dispatchEvent(new CustomEvent('theme:customer-login:close'));
  };

  CustomerLoginDrawer.prototype.checkForErrors = function() {
    // Si hay errores en el formulario de login o registro
    var loginErrors = this.drawer.querySelector('[data-login-errors]');
    if (loginErrors) {
      this.open();
    }
  };

  // Inicializar cuando el DOM esté listo
  function initCustomerLoginDrawer() {
    // console.log('🚀 Customer Login Drawer: DOM Ready, initializing...');
    var drawer = new CustomerLoginDrawer();
    // console.log('✅ Customer Login Drawer: Initialized', drawer);
  }

  // Esperar a que todo esté listo
  if (document.readyState === 'loading') {
    // console.log('⏳ Customer Login Drawer: Waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', initCustomerLoginDrawer);
  } else {
    // console.log('✅ Customer Login Drawer: DOM already loaded');
    initCustomerLoginDrawer();
  }

  // También intentar después de que window.load por si acaso
  window.addEventListener('load', function() {
    // console.log('🔄 Customer Login Drawer: Window loaded, checking if initialized...');
    var drawer = document.querySelector('[data-customer-login-drawer]');
    if (drawer && !drawer.classList.contains('initialized')) {
      // console.log('⚠️ Customer Login Drawer: Not initialized yet, retrying...');
      initCustomerLoginDrawer();
    }
  });

})();
